import React from 'react';
import Layout from 'components/common/NewLayout';
import Title from 'components/personal/Title';
import Section1 from 'components/personal/Section1';
import Section2 from 'components/personal/Section2';
import Faq from 'components/personal/Faq';
import Bottom from 'components/personal/Bottom';
import Meta from 'components/common/Meta';

const Personal = () => {
  return (
    <Layout theme="black">
      <Meta
        title="서비스 소개 - 개인 | 몰파이"
        ogTitle="서비스 소개 - 개인 | 몰파이"
      />
      <Title />
      <Section1 />
      <Section2 />
      <Faq />
      <Bottom />
    </Layout>
  );
};

export default Personal;
